import { Controller } from '@hotwired/stimulus';
import { TurboMixin } from '../../../mixins/turbo_mixin';

export default class extends Controller {
  static targets = ['searchRepresentativeUrl', 'emailInput']

  initialize() {
    TurboMixin(this);
  }

  async search () {
    this.turboGet(this.searchRepresentativeUrlTarget.dataset.url, { email: this.emailInputTarget.value })
  }
}
